import React, {JSX} from 'react';
import {RootLayout, RsnButton, RsnCarousel, RsnTextButton, styles} from '~/library/ui-kit';
import {FigureLayout} from '../../../onboarding-drafts/ui/layouts/FigureLayout';
import * as vanilla from './css/WelcomeScreen.css';
import * as imgs from './imgs';

export type WelcomeScreenProps = {
    onGoToSignup: () => void;
    onGoToLogin: () => void;
};

export const WelcomeScreen = ({onGoToLogin, onGoToSignup}: WelcomeScreenProps) => {
    return (
        <RootLayout
            pageHeader={
                <RootLayout.BaseHeader bg='none'>
                    <RootLayout.CompanyLogo />
                </RootLayout.BaseHeader>
            }
        >
            <div className={cls.page}>
                <div className='flex-1'>
                    <RsnCarousel slides={slides}>
                        {slide => (
                            <div key={slide.key} className={`${slide.className} px-4`}>
                                <FigureLayout heading={slide.data.heading} details={slide.data.details}>
                                    {slide.data.figure}
                                </FigureLayout>
                            </div>
                        )}
                    </RsnCarousel>
                </div>

                <div className={cls.btnBlock}>
                    <RsnButton.Primary onClick={onGoToLogin}>Log in</RsnButton.Primary>
                    <div className={'flex h-11 w-full items-center justify-center'}>
                        <span className={'fv-text-l-regular text-neutral-60'}>
                            New to Raison?{' '}
                            <RsnTextButton.Inline size={'l'} onClick={onGoToSignup}>
                                Create an account
                            </RsnTextButton.Inline>
                        </span>
                    </div>
                </div>
            </div>
        </RootLayout>
    );
};

const cls = styles({
    ...vanilla,
    page: 'flex flex-1 flex-col gap-12 pb-4',
    btnBlock: 'mt-auto grid gap-2 px-4',
});

const picture = (avif: string, webp: string) => <FigureLayout.Picture avif={avif} webp={webp} />;

const slide = (logo: string, text: string) => (
    <div className={cls.slide4Square}>
        <img src={logo} className='max-w-full' alt='' />
        <span className={cls.slide4Font}>{text}</span>
    </div>
);

const slides = [
    {
        figure: picture(imgs.slide1avif, imgs.slide1webp),
        heading: 'Welcome to your digital family office!',
        details: 'Comprehensive solutions, from launching an investment path to growing the existing wealth.',
    },
    {
        figure: picture(imgs.slide2avif, imgs.slide2webp),
        heading: 'Tailors specific needs of every investor',
        details: "Ultimate investment app for everyone. It doesn't cost you anything to start with a free account.",
    },
    {
        figure: picture(imgs.slide3avif, imgs.slide3webp),
        heading: 'A unique set of investment solutions',
        details:
            'Invest in top-tier venture deals. Buy public stocks and structured notes. Access trust asset management.',
    },
    {
        figure: (
            <div className={cls.slide4Grid}>
                {slide(imgs.slide4Logo1, 'Client Service Excellence\n2025')}
                {slide(imgs.slide4Logo1, 'Best Digital Wealth Platform\n2025')}
                {slide(imgs.slide4Logo2, 'Digital Wealth Management Platforms 2025')}
                {slide(imgs.slide4Logo3, 'Best Investor, Finalist\n2025')}
            </div>
        ),
        heading: "Together we'll amplify your wealth",
        details: (
            <div>
                Start your journey right now. <br /> What are you waiting for?
            </div>
        ),
    },
] satisfies Array<{
    figure: JSX.Element;
    heading: JSX.Element | string;
    details: JSX.Element | string;
}>;
